// extracted by mini-css-extract-plugin
export default {"textarea":"ArticleTextInputs_textarea__4y57d"};